import { render, staticRenderFns } from "./EditInvoiceModal.vue?vue&type=template&id=37520596&"
import script from "./EditInvoiceModal.vue?vue&type=script&lang=ts&"
export * from "./EditInvoiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports